import React from "react";

//dropdown icons
import u43 from '../../images/hsa-dashboard/u43.png'


//dashboard icons
import u427 from '../../images/accounts/u427.png'
import u224 from '../../images/hsa-dashboard/u224.png'
//account icons
import u215 from '../../images/hsa-dashboard/u215.png'
import u418 from '../../images/accounts/u418.png'
//account management icons u170u1192
import u170 from '../../images/accounts-management/u170.png'
import u1192 from '../../images/accounts-management/u1192.png'
//resources icons
import u239 from '../../images/hsa-dashboard/u239.png'
import u2203 from '../../images/resources/u2203.png'
import { Colors } from "../../design/Colors";


export default class Nav extends React.Component{
    constructor(props){
        super(props);
        this.state={
            accounts_is_dropped:true,
            claims_is_dropped:true
        }
    }

    render(){
        const {enrollment_stage,page,account_management_stage} = this.props;
        const {accounts_is_dropped,claims_is_dropped}=this.state
        return(
            <div style={{display:'flex',paddingTop:"2vh", width:"30.1vw",justifyContent:'flex-end',paddingRight:"1%"}}>
                <div >
                    <div style={styles.navItem} > {/**Dashboard Nav Item */}
                        <div>
                            <img style={{ maxHeight: '100%', width: 'auto' }} src={page==="dashboard"?u224:u427} alt='u427u224'/>
                        </div>
                        <span onClick={()=>{this.props.navigator('/Dashboard');}} style={page==="dashboard"?styles.iconedNavTextSelected:styles.iconedNavText}>Dashboard</span>
                    </div>
                    <div style={styles.dropdownItem} onClick={()=>{this.setState({accounts_is_dropped:!accounts_is_dropped})}}> {/**Accounts Dropdown Item */}
                        <div style={{alignItems:'center'}}>
                            <img style={{ maxHeight: '100%', width: 'auto' }} src={page.includes('enrollment')?u418:u215} alt='u418u215'/>
                        </div>
                        <span style={page.includes('account')?styles.iconedNavTextSelected:styles.iconedNavText}>Enrollment</span>
                        <div style={styles.dropdownIcon}>
                            <img style={{ maxHeight: '100%', width: 'auto', transform:page.includes('enrollment')?'scaleY(-1)': 'scaleY(1)'}} src={u43} alt='u43'/>
                        </div>
                    </div>
                    {accounts_is_dropped?<div style={styles.dropdownContainer}> {/**Accounts Dropdown Group */}
                        <div onClick={()=>{this.props.navigator('/Enrollment');}} style={styles.indentedNavItem}>
                            {<div style={enrollment_stage?(enrollment_stage===1?styles.currentStage:styles.pastStage):styles.upcomingStage} />}
                            <span style={page==="accountActivity"?styles.indentedStageTextSelected:styles.indentedStageText}>New Cardholder Info</span>
                        </div>
                        <div onClick={()=>{this.props.navigator('/Enrollment')}} style={styles.indentedNavItem}>
                        {<div style={enrollment_stage?(enrollment_stage===2?styles.currentStage:(enrollment_stage===1?styles.upcomingStage:styles.pastStage)):styles.upcomingStage} />}
                            <span style={page==="accountManagement"?styles.indentedStageTextSelected:styles.indentedStageText}>Review Cardholder Info</span>
                        </div>
                        <div onClick={()=>{this.props.navigator('/Enrollment')}} style={styles.indentedNavItem}>
                        {<div style={enrollment_stage?(enrollment_stage===3?styles.currentStage:styles.upcomingStage):styles.upcomingStage} />}
                            <span style={page==="accountCards"?styles.indentedStageTextSelected:styles.indentedStageText}>Confirm Enrollment</span>
                        </div>
                    </div>:null}
                    <div style={styles.dropdownItem} onClick={()=>{this.setState({claims_is_dropped:!claims_is_dropped})}}> {/**Claims Dropdown Item */}
                        <div style={{alignItems:'center'}}>
                            <img style={{ maxHeight: '100%', width: 'auto' }} src={page==="claims"?u1192:u170} alt='u170u1192'/>
                        </div>
                        <span style={page==="claims"?styles.iconedNavTextSelected:styles.iconedNavText}>Manage Accounts</span>
                        <div style={styles.dropdownIcon}>
                            <img style={{ maxHeight: '100%', width: 'auto', transform:claims_is_dropped?'scaleY(-1)': 'scaleY(1)'}} src={u43} alt='u43'/>
                        </div>
                    </div>
                    {claims_is_dropped?<div style={styles.dropdownContainer}> {/**Claims Dropdown Group */}
                        <div onClick={()=>{this.props.navigator('/AccountReview');}} style={styles.indentedNavItem}>
                            {<div style={account_management_stage?(account_management_stage===1?styles.currentStage:styles.pastStage):styles.upcomingStage} />}
                            <span style={page==='claimsActivity'?styles.indentedStageTextSelected:styles.indentedStageText}>Find Account</span>
                        </div>
                        <div onClick={()=>{this.props.navigator('/AccountReview');}} style={styles.indentedNavItem}>
                            {<div style={account_management_stage?(account_management_stage===1?styles.upcomingStage:styles.currentStage):styles.upcomingStage} />}
                            <span  style={page==='submitExpense'?styles.indentedStageTextSelected:styles.indentedStageText}>Account Details</span>
                        </div>
                    </div>:null}
                    <div style={styles.navItem} onClick={()=>{this.props.navigator('/Resources')}}> {/**Resources Nav Item */}
                        <div>
                            <img style={{ maxHeight: '100%', width: 'auto' }} src={page==="resources"?u2203:u239} alt='u239u2203'/>
                        </div>
                        <span style={page==="resources"?styles.iconedNavTextSelected:styles.iconedNavText}>Resources</span>
                    </div>
                </div>
            </div>
        )
    }
}

const styles={
    iconedNavText:{
        display:'flex',
        alignItems: 'center',
        marginLeft:"0.5vw",
        verticalAlign: 'middle',
        width:'5vw',
        fontSize:14,
        fontWeight:400,
        fontFamily:"Helvetica",
        cursor:'pointer',
        color:"#666666",
        whiteSpace:'nowrap'
    },
    iconedNavTextSelected:{
        display:'flex',
        alignItems: 'center',
        marginLeft:"0.5vw",
        verticalAlign: 'middle',
        width:'6vw',
        fontSize:14,
        fontWeight:400,
        fontFamily:"Helvetica",
        cursor:'pointer',
        color:"#003F97",
        whiteSpace:'nowrap'
    },
    navItem:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        height:"3.5vh",
        lineHeight:'3.5vh',
    },
    dropdownItem:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        height:"3.5vh",
        lineHeight:'3.5vh',
        cursor:'pointer'
    },
    dropdownIcon:{
        display:'flex',
        alignItems:'flex-end',
        marginLeft:"3.7vw"
    },
    dropdownContainer:{
        display:'flex',
        flexDirection:'column'
    },
    indentedNavItem:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        height:"3.5vh",
        lineHeight:'3.5vh',
        whiteSpace:'nowrap'
    },
    indentedNavText:{
        display:'flex',
        alignItems: 'center',
        marginLeft:"1.7vw",
        verticalAlign: 'middle',
        fontSize:14,
        fontWeight:400,
        fontFamily:"Helvetica",
        cursor:'pointer',
        color:"#666666"
    },
    indentedStageText:{
        display:'flex',
        alignItems: 'center',
        marginLeft:"0vw",
        verticalAlign: 'middle',
        fontSize:14,
        fontWeight:400,
        fontFamily:"Helvetica",
        cursor:'pointer',
        color:"#666666"
    },
    indentedNavTextSelected:{
        display:'flex',
        alignItems: 'center',
        marginLeft:"1.7vw",
        verticalAlign: 'middle',
        fontSize:14,
        fontWeight:600,
        fontFamily:"Helvetica",
        cursor:'pointer',
        color:"#666666"
    },
    indentedStageTextSelected:{
        display:'flex',
        alignItems: 'center',
        marginLeft:"0vw",
        verticalAlign: 'middle',
        fontSize:14,
        fontWeight:600,
        fontFamily:"Helvetica",
        cursor:'pointer',
        color:"#666666"
    },
    currentStage:{display:'flex',width:'0.5vw',height:'0.5vw',border:'1px solid '+Colors.blue,backgroundColor:Colors.blue,borderRadius:100,marginLeft:'1vw',marginRight:'0.2vw'},
    pastStage:{display:'flex',width:'0.5vw',height:'0.5vw',backgroundColor:Colors.dark_grey,borderRadius:100,marginLeft:'1vw',marginRight:'0.2vw'},
    upcomingStage:{display:'flex',width:'0.5vw',height:'0.5vw',border:'1px solid '+Colors.dark_grey,backgroundColor:Colors.grey,borderRadius:100,marginLeft:'1vw',marginRight:'0.2vw'}
}